import { Injectable, Optional, SimpleChanges } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IAbstractPresenter } from '@core/interfaces';
import {
	ImageViewerStatusEnum,
	ImageViewerStatusEnumValues,
	ImageViewerCloseRoleEnum,
	ImageViewerCloseRoleEnumValues,
} from './enums';
import { IImageViewerComponent, IImageViewerPresenter } from './interfaces';

@Injectable()
export class ImageViewerModalPresenter
	extends IAbstractPresenter<IImageViewerComponent>
	implements IImageViewerPresenter
{
	status: ImageViewerStatusEnumValues = ImageViewerStatusEnum.LOADING;
	currentImageUrl: string = '';
	fallbackImageUrl: string = 'assets/plato-no-image.svg';

	constructor(@Optional() private modalCtrl?: ModalController) {
		super();
	}

	override onInit(): void {
		this.currentImageUrl = this.view.imageUrl || this.fallbackImageUrl;
		this.status = this.view.imageUrl
			? ImageViewerStatusEnum.LOADING
			: ImageViewerStatusEnum.LOADED;
	}

	override onChanges(changes: SimpleChanges): void {
		if (changes['imageUrl']) {
			const nextUrl = changes['imageUrl'].currentValue;
			this.currentImageUrl = nextUrl || this.fallbackImageUrl;
			this.status = nextUrl
				? ImageViewerStatusEnum.LOADING
				: ImageViewerStatusEnum.LOADED;
			this.cdr?.markForCheck();
		}
	}

	dispatchActions(): void {}

	suscribeObservers(): void {}

	closeModal(role: ImageViewerCloseRoleEnumValues = ImageViewerCloseRoleEnum.BUTTON): void {
		this.view.modalClose.emit(role);
		try {
			this.modalCtrl?.dismiss(undefined, role);
		} catch (_e) {
			// Fallback si no está dentro del contexto de ModalController
		}
	}

	onImgError(event: Event): void {
		const target = event.target as HTMLImageElement;
		if (target && !target.src.includes(this.fallbackImageUrl)) {
			target.src = this.fallbackImageUrl;
		}
		this.currentImageUrl = this.fallbackImageUrl;
		this.status = ImageViewerStatusEnum.ERROR;
		this.cdr?.markForCheck();
	}

	onImageLoad(): void {
		this.status = ImageViewerStatusEnum.LOADED;
		this.cdr?.markForCheck();
	}

	onBackdropClick(event: MouseEvent): void {
		if (event.target === event.currentTarget) {
			this.closeModal(ImageViewerCloseRoleEnum.BACKDROP);
		}
	}
}
